import { render, staticRenderFns } from "./aufgaben.vue?vue&type=template&id=d006b8a8&scoped=true&"
import script from "./aufgaben.vue?vue&type=script&lang=js&"
export * from "./aufgaben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d006b8a8",
  null
  
)

export default component.exports